// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__1yxZG","copyright":"copyright__3lK7Q","socialIcons":"socialIcons__qdhtB","logo":"logo__3MaHB","left":"left__2OeWL","right":"right__1aDsX","footerLinks":"footerLinks__3SXWO"};


//////////////////
// WEBPACK FOOTER
// ./components/global/footer/style.scss
// module id = yfLs
// module chunks = 27